<!--
 * @Author: 月魂
 * @Date: 2021-01-27 14:14:55
 * @LastEditTime: 2022-01-31 13:37:27
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Home.vue
-->
<template>
  <div class="home">
    <img
      src="http://image.wearetogether.com.cn/enter.png"
      class="btn"
      @click="() => this.$router.push('/preface')"
    />
    <van-swipe
      indicator-color="white"
      :autoplay="5000"
      width="100%"
      height="100%"
    >
      <van-swipe-item v-for="item in list" :key="item">
        <img
          :src="
            'http://image.wearetogether.com.cn/swipe-ukraine-' + item + '.jpg'
          "
          style="display: block; width: 100vw; height: 100vh;"
        />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      list: [ '1-1', 2, '3-1', 4, 5, 6, '7-1', 8 ],
    }
  }
}
</script>

<style scoped lang="less">
.home {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.btn {
  width: 30%;
  position: absolute;
  bottom: 15%;
  right: 20px;
  color: #fff;
  z-index: 1;
}
</style>
